import styled from 'styled-components'
import { ReactComponent as CircleLogo } from '../../assets/CircleLogo.svg'

import { noSelectDragCss } from '@anyonelab/common'

export const CircleLogoStyled = styled(CircleLogo)`
  ${noSelectDragCss}
`
